import * as Yup from 'yup';

import type { DropdownOption } from '@/types/common.type';

export const roleCreateSchema = Yup.object().shape({
  name: Yup.string().required('Role name is required'),
  description: Yup.string().required('Role description is required'),
  permissions: Yup.array()
    .of(Yup.object<DropdownOption>())
    .required('At least one permission must be selected')
    .min(1, 'At least one permission must be selected'),
});

export type CreateRoleFormValues = Yup.InferType<typeof roleCreateSchema>;

export const roleUpdateSchema = Yup.object().shape({
  name: Yup.string().required('Role name is required'),
  description: Yup.string().required('Role description is required'),
  add_permission_ids: Yup.array().of(Yup.number()),
  remove_permission_ids: Yup.array().of(Yup.number()),
  hasPermissionsSelected: Yup.boolean().default(false),
});

export type UpdateRoleFormValues = Yup.InferType<typeof roleUpdateSchema>;
